import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { logout, getRole } from '../../admin/api';
import BookingsPanel from '../../admin/BookingsPanel';
import MarketingPanel from '../../admin/MarketingPanel';
import RewardsPanel from '../../admin/RewardsPanel';
import Icon from '../../admin/Icon';
import ThemeToggle from '../../admin/ThemeToggle';
import '../../admin/admin.css';

const NAV = [
  { key: 'calendar', label: 'Calendar', icon: 'calendar', sub: 'Month view of appointments' },
  { key: 'list', label: 'All bookings', icon: 'list', sub: 'Search & manage every booking' },
  { key: 'marketing', label: 'Marketing', icon: 'message', sub: 'Send SMS promos to customers' },
  { key: 'rewards', label: 'Rewards', icon: 'gift', sub: 'Look up & redeem customer points' },
];

const ManagerDashboard = () => {
  const navigate = useNavigate();
  const viewingAsWebmaster = getRole() === 'webmaster';
  const [view, setView] = useState('calendar');
  const [mobileNav, setMobileNav] = useState(false);
  const handleLogout = () => { logout(); navigate('/portal/login', { replace: true }); };
  const active = NAV.find((n) => n.key === view) || NAV[0];
  const go = (key) => { setView(key); setMobileNav(false); };

  return (
    <div className="wm-layout manager-theme">
      <aside className={`wm-sidebar ${mobileNav ? 'open' : ''}`}>
        <div className="wm-brand">
          <span className="brand-mark mgr"><Icon name="receipt" size={22} /></span>
          <div>
            <h1>Shop Manager</h1>
            <p>JG Detailing</p>
          </div>
        </div>

        <nav className="wm-nav">
          {NAV.map((n) => (
            <button key={n.key} className={`wm-nav-item ${view === n.key ? 'active' : ''}`} onClick={() => go(n.key)}>
              <span className="wm-nav-icon"><Icon name={n.icon} size={19} /></span>
              <span className="wm-nav-text">
                <span className="wm-nav-label">{n.label}</span>
                <span className="wm-nav-sub">{n.sub}</span>
              </span>
            </button>
          ))}
        </nav>

        <div className="wm-sidebar-foot">
          <ThemeToggle />
          {viewingAsWebmaster ? (
            <button className="admin-ghost-btn wm-viewas" onClick={() => navigate('/portal/webmaster')}><Icon name="arrow-left" size={16} /> Back to Webmaster</button>
          ) : (
            <button className="admin-ghost-btn wm-logout" onClick={handleLogout}><Icon name="power" size={16} /> Log out</button>
          )}
        </div>
      </aside>

      {mobileNav && <div className="wm-scrim" onClick={() => setMobileNav(false)} />}

      <div className="wm-content">
        {viewingAsWebmaster && (
          <div className="impersonation-bar">
            <span><Icon name="eye" size={15} /> You’re viewing the Shop Manager dashboard as <strong>Webmaster</strong>.</span>
            <button onClick={() => navigate('/portal/webmaster')}><Icon name="arrow-left" size={14} /> Back to Webmaster</button>
          </div>
        )}

        <header className="wm-content-head">
          <button className="wm-burger" onClick={() => setMobileNav(true)} aria-label="Open menu"><Icon name="menu" size={20} /></button>
          <div className="wm-head-title">
            <span className="wm-head-icon"><Icon name={active.icon} size={23} /></span>
            <div>
              <h2>{active.label}</h2>
              <p>{active.sub}</p>
            </div>
          </div>
          <div className="wm-head-actions" id="bookings-head-actions" />
        </header>

        <main className="wm-main">
          {view === 'marketing'
            ? <MarketingPanel />
            : view === 'rewards'
            ? <RewardsPanel />
            : <BookingsPanel allowBoard={false} view={view} onViewChange={setView} showTabs={false} />}
        </main>
      </div>
    </div>
  );
};

export default ManagerDashboard;
